export default "__VITE_PUBLIC_ASSET__a011336e__"